import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/materials/bcp-priced')({
  staticData: {
    title: 'route.materials.bcpPriced',
    crumb: 'route.materials.bcpPriced',
    permissions: ['materials_bcp_priced_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
